export default "__VITE_ASSET__PsHlg1yq__"